import type { ParsedUrlQuery } from 'querystring';

import type { SanitisedVehicleListQuery } from 'Components/VehicleList/VehicleListFilterQuery.schema';
import { VehicleListQuerySchema } from 'Components/VehicleList/VehicleListFilterQuery.schema';

// Removed from helpers due to creation of circular dependency
export const sanitiseVehicleListQuery = (query: ParsedUrlQuery): SanitisedVehicleListQuery =>
	VehicleListQuerySchema.parse(query);
